import     {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, F, RE} from "../_common/layout";

import { Form as FinalForm} from "react-final-form";
import {
    FormField, SubmitButtonRow
} from "../_common/forms/components/components";
import {doLogin, recoverPassword} from "../_rx/_auth/actions";

import {Link} from "react-router-dom";
import AlertBox from "../_common/components/AlertBox/AlertBox";
import {ButtonPrimary} from "../_common/components/buttons/buttons";


type Props = { doLogin:typeof doLogin, recoverPassword: typeof recoverPassword};

export const validateMail = (text: string) => {
    if (text === undefined || text === null || text === ''){
        return 'Por favor, introduce el correo electrónico'
    } else if (!text?.match(/^[\w-\.\+]+@([\w-]+\.)+[\w-]{2,4}$/g)){
        return 'Por favor, introduce un correo electrónico valido'
    }

}

class View extends Component<Props,{recover:boolean,recoverDone:boolean}> {

    state = {recover:false, recoverDone:false};

    async onSubmit(login: any){
        if (this.state.recover) {
            await this.props.recoverPassword(login.email)
            this.setState({recoverDone: true})
        } else
            await this.props.doLogin(login);
    }

    render() {
        return <FinalForm
            onSubmit={(data:any)=>this.onSubmit(data)}
            render={({handleSubmit,  submitting}:any)=>
                <form className='form' action="" onSubmit={handleSubmit}  noValidate><F className='max-width'>
                    <C>
                        <h2 className="m-bottom">{this.state.recover ? "Recuperar contraseña" : "Iniciar sesión"}</h2>
                        {this.state.recoverDone ? <Fragment>
                            <p><a href="#" onClick={(e)=>{e.preventDefault();this.setState({recover:false, recoverDone:false})}}>← Volver</a></p>
                            <AlertBox type='info'><span>Se ha enviado un email con instrucciones.</span></AlertBox>
                        </Fragment>: <Fragment>
                            <RE><FormField label={'Email'} name="email" type={'email'} required validate={validateMail}/></RE>
                            {!this.state.recover && <Fragment>
                                <RE><FormField label={'Contraseña'} name="password" type="password" required /></RE>
                                <RE className="t-right"><a href="#" onClick={(e)=>{e.preventDefault();this.setState({recover:true})}}>Recuperar contraseña</a></RE>
                            </Fragment>}

                            <div className='d-flex flex-bottom flex-space-between m-top'>
                                <ButtonPrimary disabled={submitting}>Enviar</ButtonPrimary>
                                {this.state.recover && <div className='text-primary t-underline cursor-pointer' onClick={() => this.setState({recover:false})}>Volver a iniciar sesión</div>}
                            </div>

                        </Fragment>}

                        {/*<hr className="separator-sm"/>*/}
                        {/*<Link className="btn btn-ghost full-width" to="/company/new">Registra tu empresa</Link>*/}
                    </C>
                </F>
                </form>}/>;
    }
}

const ConnectedView: any = connect(
    ()=>({}), {doLogin, recoverPassword})(View as any);

export default () =>
    <AppPage
        name="company-login"
        title={t('Bolsa de trabajo')}
        subtitle=""
        className="max-width">
        <ConnectedView />
    </AppPage>
;

